<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex md12>
        <material-card>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm6 md6>
                <v-btn color="general" light class="mb-2" @click="newItem">{{
                  $t("language.new")
                }}</v-btn>
              </v-flex>
              <!-- <v-flex xs12 sm6 md6>
                <v-text-field
                  v-model="grid.search"
                  append-icon="search"
                  :label="$t('language.search')"
                  single-line
                  hide-details
                ></v-text-field>
              </v-flex> -->
            </v-layout>
          </v-container>
          <v-dialog v-model="dialog" max-width="600px">
            <ValidationObserver ref="form" v-slot="{ passes }">
              <v-form @submit.prevent="passes(save)">
                <v-card>
                  <v-card-title>{{
                    $t("language.leaveapplication")
                  }}</v-card-title>
                  <v-card-text>
                    <v-container grid-list-md>
                      <v-layout wrap>
                        <v-flex xs12 sm6 md4>
                          <ValidationProvider
                            :name="$t('language.leave')"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <v-autocomplete
                              dense
                              v-model="vModel.leaveid"
                              :items="LeaveList"
                              item-text="name"
                              item-value="id"
                              :label="$t('language.leave')"
                              :error-messages="errors[0]"
                              :clearable="true"
                            ></v-autocomplete>
                          </ValidationProvider>
                        </v-flex>
                        <v-flex xs12 sm12 md4>
                          <ValidationProvider
                            :name="$t('language.fromdate')"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <eng-nep-date-picker
                              :error-messages="errors[0]"
                              v-model="vModel.fromdate"
                              :label="$t('language.fromdate')"
                            ></eng-nep-date-picker>
                          </ValidationProvider>
                        </v-flex>
                        <v-flex xs12 sm12 md4>
                          <ValidationProvider
                            :name="$t('language.todate')"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <eng-nep-date-picker
                              :error-messages="errors[0]"
                              v-model="vModel.todate"
                              :label="$t('language.todate')"
                            ></eng-nep-date-picker>
                          </ValidationProvider>
                        </v-flex>
                        <v-flex xs12 sm6 md4>
                          <v-switch
                            :label="$t('language.ishalfday')"
                            v-model="vModel.ishalfday"
                          ></v-switch>
                        </v-flex>
                        <v-flex xs12 sm12 md4>
                          <v-text-field
                            disabled
                            dense
                            v-model="totaldays"
                            :label="$t('language.days')"
                          />
                        </v-flex>
                        <v-flex xs12 sm6 md4>
                          <ValidationProvider
                            :name="$t('language.approver')"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <v-autocomplete
                              dense
                              v-model="vModel.approvedbyid"
                              :items="ApproverList"
                              item-text="name"
                              item-value="id"
                              :label="$t('language.approver')"
                              :error-messages="errors[0]"
                              :clearable="true"
                            ></v-autocomplete>
                          </ValidationProvider>
                        </v-flex>
                        <v-flex
                          xs12
                          sm6
                          md4
                          v-if="$store.getters.settings.enablerecommender"
                        >
                          <ValidationProvider
                            :name="$t('language.recommender')"
                            v-slot="{ errors }"
                          >
                            <v-autocomplete
                              dense
                              v-model="vModel.recommendedbyid"
                              :items="RecommenderList"
                              item-text="name"
                              item-value="id"
                              :label="$t('language.recommender')"
                              :error-messages="errors[0]"
                              :clearable="true"
                            ></v-autocomplete>
                          </ValidationProvider>
                        </v-flex>
                        <v-flex xs12 sm6 md8>
                          <ValidationProvider
                            :name="$t('language.remarks')"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <v-text-field
                              dense
                              v-model="vModel.remarks"
                              :label="$t('language.remarks')"
                              :error-messages="errors[0]"
                            />
                          </ValidationProvider>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer />
                    <v-btn
                      dense
                      color="grey darken-1"
                      text
                      @click="closedialog"
                      >{{ $t("language.cancel") }}</v-btn
                    >
                    <v-btn dense color="blue darken-1" text type="submit">{{
                      $t("language.save")
                    }}</v-btn>
                  </v-card-actions>
                </v-card>
              </v-form>
            </ValidationObserver>
          </v-dialog>

          <v-data-table
            :headers="grid.headers"
            :items="grid.body"
            :search="grid.search"
            :options.sync="grid.options"
            :server-items-length="grid.total"
            :loading="grid.loading"
            :footer-props="grid.footerProps"
              :items-per-page="grid.itemsperpage"
            class="elevation-2"
          >
            <template v-slot:header.fromdate>
              <span>{{ $t("language.fromdate") }}</span>
            </template>
            <template v-slot:header.todate>
              <span>{{ $t("language.todate") }}</span>
            </template>
            <template v-slot:header.totaldays>
              <span>{{ $t("language.days") }}</span>
            </template>
            <template v-slot:header.leave>
              <span>{{ $t("language.leave") }}</span>
            </template>
            <template v-slot:header.approver>
              <span>{{ $t("language.approver") }}</span>
            </template>
            <template v-slot:header.remarks>
              <span>{{ $t("language.remarks") }}</span>
            </template>
            <template v-slot:item.fromdate="{ item }">
              {{getDefaultDate(item.fromdate)}}
            </template>
            <template v-slot:item.todate="{ item }">
              {{getDefaultDate(item.todate)}}
            </template>
            <template v-slot:item.action="{ item }">
              <v-icon small @click="deleteItem(item.id)">delete</v-icon>
            </template>
          </v-data-table>
        </material-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from "axios";
import moment from "moment";
import Base from "../../../shared/Base.vue";
import EngNepDatePicker from "../../../components/shared/EngNepDatePicker";
import commonservice from "../../../shared/common.service";
export default {
  name: "leaveapplicationview",
  extends: Base,
  components: {
    EngNepDatePicker,
  },
  data() {
    return {
      LeaveList: [],
      ApproverList: [],
      RecommenderList: [],
      totaldays: 0,
    };
  },
  watch: {
    "vModel.fromdate": {
      handler() {
        this.calculatedays();
      },
      deep: true,
    },
    "vModel.todate": {
      handler() {
        this.calculatedays();
      },
      deep: true,
    },
    "vModel.leaveid": {
      handler() {
        this.calculatedays();
      },
      deep: true,
    },
  },
  beforeRouteEnter(to, from, next) {
    axios.get("client/application/leaves/init/list").then((response) => {
      next((p) => {
        p.LeaveList = response.data.leaves;
        p.ApproverList = response.data.approvers;
        p.RecommenderList = response.data.recommenders;
      });
    });
  },
  created() {
    this.grid.headers = [
      { value: "fromdate" },
      { value: "todate" },
      { value: "totaldays" },
      { value: "leave" },
      { value: "approver" },
      { value: "remarks" },
      { value: "action", sortable: false },
    ];
    this.vModel = {
      id: null,
      fromdate: moment().format("YYYY-MM-DD"),
      todate: moment().format("YYYY-MM-DD"),
      leaveid: null,
      remarks: null,
      approvedbyid: null,
      recommendedbyid: null,
      ishalfday: false,
    };
    this.url = "client/application/leaves";
  },
  methods: {
    calculatedays() {
      if (this.vModel.ishalfday) {
        this.vModel.todate = this.vModel.fromdate;
        return 0.5;
      }
      if (this.vModel.fromdate != null && this.vModel.todate == null)
        this.vModel.todate = this.vModel.fromdate;
      else if (this.vModel.fromdate == null && this.vModel.todate != null)
        this.vModel.fromdate = this.vModel.todate;
      else if (new Date(this.vModel.fromdate) > new Date(this.vModel.todate))
        this.vModel.todate = this.vModel.fromdate;
      if (
        this.vModel.fromdate != null &&
        this.vModel.todate != null &&
        this.vModel.leaveid != null
      ) {
        axios
          .post("client/application/leaves/get/days", {
            fromdate: this.vModel.fromdate,
            todate: this.vModel.todate,
            leaveid: this.vModel.leaveid,
          })
          .then((response) => {
            this.totaldays =
              commonservice.getDays(this.vModel.fromdate, this.vModel.todate) -
              response.data.deducteddays;
          });
      } else
        this.totaldays = commonservice.getDays(
          this.vModel.fromdate,
          this.vModel.todate
        );
    },
  },
};
</script>
